import { CarouselScrollDirective } from './directives/carousel-scroll.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/layout/material.module';
import { TableComponent } from './components/table/table.component';
import { CardComponent } from './components/card/card.component';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from './components/modal/modal.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { MiniCardComponent } from './components/mini-card/mini-card.component';
import { DateTimePipe } from './pipes/date-time.pipe';
import { FileUploadSelectorComponent } from './components/file-upload-selector/file-upload-selector.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { FileDownloadLinkComponent } from './components/file-download-link/file-download-link.component';
import { SectionTitleComponent } from './components/section-title/section-title.component';
import { ValidateCpfDirective } from './directives/validate-cpf.directive';
import { FloatingPaginatorFadeDirective } from './directives/floating-paginator-fade.directive';
import { MaskProtocoloDirective } from './directives/mask-protocolo.directive';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { TutorialCardComponent } from './components/tutorial-card/tutorial-card.component';
import { FilterCardLineComponent } from './components/filter-card-line/filter-card-line.component';
import { MenuCardComponent } from './components/menu-card/menu-card.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { ProgressFlowLinesDirective } from './directives/progress-flow-lines.directive';
import { PadStartPipe } from './pipes/pad-start.pipe';
import { EspecificacaoTituloPipe } from './pipes/especificacao-titulo.pipe';
import { ItemSelectionAccordionComponent } from './components/item-selection-accordion/item-selection-accordion.component';
import { LinkifySolicitacaoPipe } from './pipes/linkify-solicitacao.pipe';
import { TituloSituacaoSolicitacaoPipe } from './pipes/titulo-situacao-solicitacao.pipe';
import { MdiComposedDirective } from './directives/mdi-composed.directive';
import { TextSlideOverflowDirective } from './directives/text-slide-overflow.directive';
import { TemplateContextDirective } from './directives/template-context.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { AllowedCharsDirective } from './directives/allowed-chars.directive';
import { ConvertMonetaryPipe } from './pipes/convert-monetary.pipe';
import { CapitalizeWordsPipe } from './pipes/capitalize-words.pipe';
import { WhatsappLinkPipe } from './pipes/whatsapp-link.pipe';
import { RemoverCaracteresPipe } from './pipes/remover-caracteres.pipe';
import { ToNumberOrNullPipe } from './pipes/to-number-or-null.pipe';
import { ContadorRichTextPipe } from './pipes/contador-despacho.pipe';
import { ExpandableContentPipe } from './pipes/expandable-content.pipe';
import { FormatCpfCnpjPipe } from './pipes/format-cpf-cnpj.pipe';
import { NomeGuerraPGDirective } from './directives/nome-guerra-pg.directive';
import { PreferenciaNotificacaoComponent } from '../main/notificacao/preferencia-notificacao/preferencia-notificacao.component';
import { NanoCardAccordionComponent } from './components/nano-card-accordion/nano-card-accordion.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { RichTextViewerComponent } from './components/rich-text-viewer/rich-text-viewer.component';
import { ListStateComponent } from './components/list-state/list-state.component';

@NgModule({
  declarations: [
    ListStateComponent,
    SafeUrlPipe,
    DateTimePipe,
    PadStartPipe,
    EspecificacaoTituloPipe,
    TituloSituacaoSolicitacaoPipe,
    CardComponent,
    TableComponent,
    PerfilComponent,
    SpinnerComponent,
    MiniCardComponent,
    NanoCardAccordionComponent,
    MenuCardComponent,
    TemplateContextDirective,
    DatePickerComponent,
    PreferenciaNotificacaoComponent,
    ValidateCpfDirective,
    MaskProtocoloDirective,
    MdiComposedDirective,
    TextSlideOverflowDirective,
    SectionTitleComponent,
    TutorialCardComponent,
    LinkifySolicitacaoPipe,
    ConvertMonetaryPipe,
    CapitalizeWordsPipe,
    WhatsappLinkPipe,
    RemoverCaracteresPipe,
    ToNumberOrNullPipe,
    ContadorRichTextPipe,
    ExpandableContentPipe,
    FormatCpfCnpjPipe,
    FilterCardLineComponent,
    FileDownloadLinkComponent,
    ProgressFlowLinesDirective,
    FileUploadSelectorComponent,
    FileViewerComponent,
    NumbersOnlyDirective,
    AllowedCharsDirective,
    FloatingPaginatorFadeDirective,
    ItemSelectionAccordionComponent,
    NomeGuerraPGDirective,
    RichTextViewerComponent,
  ],
  imports: [
    CarouselScrollDirective,CommonModule, ReactiveFormsModule, RouterModule, FormsModule, MaterialModule, NgxMaskDirective, NgxMaskPipe, ModalComponent, RichTextEditorComponent],
  exports: [
    ListStateComponent,
    CarouselScrollDirective,
    // Modules
    FormsModule,
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,

    // Pipes
    NgxMaskPipe,
    SafeUrlPipe,
    DateTimePipe,
    PadStartPipe,
    EspecificacaoTituloPipe,
    LinkifySolicitacaoPipe,
    TituloSituacaoSolicitacaoPipe,
    ConvertMonetaryPipe,
    CapitalizeWordsPipe,
    WhatsappLinkPipe,
    RemoverCaracteresPipe,
    ToNumberOrNullPipe,
    ContadorRichTextPipe,
    ExpandableContentPipe,
    FormatCpfCnpjPipe,

    // Directives
    NgxMaskDirective,
    MdiComposedDirective,
    ValidateCpfDirective,
    MaskProtocoloDirective,
    TemplateContextDirective,
    TextSlideOverflowDirective,
    ProgressFlowLinesDirective,
    FloatingPaginatorFadeDirective,
    NumbersOnlyDirective,
    AllowedCharsDirective,
    NomeGuerraPGDirective,

    // Components
    CardComponent,
    TableComponent,
    ModalComponent,
    PerfilComponent,
    SpinnerComponent,
    MiniCardComponent,
    NanoCardAccordionComponent,
    MenuCardComponent,
    DatePickerComponent,
    TutorialCardComponent,
    SectionTitleComponent,
    FilterCardLineComponent,
    FileDownloadLinkComponent,
    FileUploadSelectorComponent,
    FileViewerComponent,
    ItemSelectionAccordionComponent,
    PreferenciaNotificacaoComponent,
    RichTextEditorComponent,
    RichTextViewerComponent,
  ],
  providers: [],
})
export class SharedModule {}
